import React, { useState, useEffect } from "react";
import { Grid, InputLabel, MenuItem } from "@mui/material";
import {
  PrimaryOutlinedButton,
  PrimaryLightInput,
  PrimaryLightSelect,
} from "../../theme/index";
import "../../sass/styles.scss";
import FormControl from "@mui/material/FormControl";
import { UseScreen } from "../../hooks/UseScreen.hook";
import { useDispatch } from "react-redux";
import { modalAction } from "../../redux/reducers/Modal";
import { createRoomAction } from "../../redux/reducers/Create";
import axios from "axios";
import {collection, getDocs, addDoc, query, doc} from 'firebase/firestore';
import db from "../../config/firebase";

const CreateRoom = () => {
  const screenWidth = UseScreen();
  const dispatch = useDispatch();
  const [roomNumber, setRoomNumber] = useState("");
  const [category, setCategory] = useState("");
  const [price, setPrice] = useState("");
  const [expressPrice, setExpressPrice] = useState("");
  const [level, setLevel] = useState(0);
  const [levels, setLevels] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [status, setStatus] = useState("");
  const [details, setDetails] = useState("");

  useEffect(() => {
    const getLevels = async () => {
      const q = query(collection(db, "level"));
      const querySnapshot = await getDocs(q);
      let arrayLevels = [];
      querySnapshot.forEach((doc) => {
        arrayLevels.push(doc.data());
      });
      setLevels(arrayLevels);
    };

    const getCategories = async () => {
      const q = query(collection(db, "category"));
      const querySnapshot = await getDocs(q);
      let arrayCategories = [];
      querySnapshot.forEach((doc) => {
        arrayCategories.push({id: doc.id, ...doc.data()});
      });
      setCategoryList(arrayCategories);
    };

    getLevels();
    getCategories();
  }, []);

  const saveData = async () => {
    const room = new FormData();
    const dataNames = [
      "roomNumber",
      "category",
      "price",
      "expressPrice",
      "level",
      "status",
      "details",
    ];

    room.append(dataNames[0], roomNumber);
    room.append(dataNames[1], category);
    room.append(dataNames[2], price);
    room.append(dataNames[3], expressPrice);
    room.append(dataNames[4], level);
    room.append(dataNames[5], status);
    room.append(dataNames[6], details);
    room.append("METHOD", "POST");

    dispatch(createRoomAction(room, dataNames));
    dispatch(modalAction());
  };

  return (
    <>
      <Grid item xs={10}>
        <h5 style={{ margin: "0" }}>Habitación / nueva</h5>
      </Grid>
      <Grid item xs={12}>
        <Grid container sx={{ py: 6 }}>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Número"
              fullWidth
              onChange={(e) => setRoomNumber(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Categoría</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                onChange={(e) => setCategory(e.target.value)}
              >
                {categoryList.length > 0 &&
                  categoryList.map((item) => {
                    if (item.status == "true") {
                      return (
                        <MenuItem value={item.name.toLowerCase()}>
                          {item.name}
                        </MenuItem>
                      );
                    }
                  })}
                {/* <MenuItem value='double-bed'>Matrimonial</MenuItem>
                            <MenuItem value='personal'>Personal</MenuItem>
                            <MenuItem value='double'>Doble</MenuItem>
                            <MenuItem value='junior-suite'>Junior Suite</MenuItem>
                            <MenuItem value='suite'>Suite</MenuItem> */}
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Precio Estándar"
              fullWidth
              onChange={(e) => setPrice(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={3} sx={{ mb: 2 }} className="pr-2">
            <PrimaryLightInput
              label="Precio Express"
              fullWidth
              onChange={(e) => setExpressPrice(e.target.value)}
            />
          </Grid>
          <Grid item xs={12} md={6} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Piso</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                onChange={(e) => setLevel(e.target.value)}
              >
                {levels.length > 0 &&
                  levels.map((item) => {
                    if (item.status == "true") {
                      return <MenuItem value={item.name}>{item.name}</MenuItem>;
                    }
                  })}
                {/* <MenuItem value={1}>Primer nivel</MenuItem>
                            <MenuItem value={2}>Segundo nivel</MenuItem>
                            <MenuItem value={3}>Tercer nivel</MenuItem> */}
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} sx={{ mb: 2 }} className="pr-2">
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Status</InputLabel>
              <PrimaryLightSelect
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                label="Status"
                onChange={(e) => setStatus(e.target.value)}
              >
                {/* <MenuItem value='true'>Activo</MenuItem> */}
                <MenuItem value="open">Abierto</MenuItem>
                <MenuItem value="close">Cerrado</MenuItem>
                <MenuItem value="cleaning">En limpieza</MenuItem>
                <MenuItem value="false">Inactivo</MenuItem>
              </PrimaryLightSelect>
            </FormControl>
          </Grid>
          <Grid item xs={12} className="pr-2">
            <PrimaryLightInput
              label="Detalles"
              fullWidth
              multiline
              onChange={(e) => setDetails(e.target.value)}
              rows={screenWidth > 500 ? 4 : 2}
            />
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12} sx={{ mt: 2 }} textAlign="end" className="pr-2">
        <PrimaryOutlinedButton onClick={() => saveData()}>
          Guardar
        </PrimaryOutlinedButton>
      </Grid>
    </>
  );
};

export default CreateRoom;
